import { render } from "./InstitutionForm.vue?vue&type=template&id=2dba2b64&lang=pug"
import script from "./InstitutionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__